import Vuetify from '@/plugins/vuetify';

export default {
  questionarios: [],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    questionario: '',
    statusQuestionario: '',
    codigoCqc: null,
  },
  colunasQuestionarios: [
    {
      field: 'codigoCqc',
      sortable: true,
      comparator: () => false,
      filter: 'NumberFilter',
      filterParams: {
        module: 'questionarios',
        fetch: 'listarQuestionarios',
        colDef: {
          field: 'codigoCqc',
        },
      },
      headerName: Vuetify.framework.lang.t('$vuetify.sequencial'),
      maxWidth: 150,
      minWidth: 150,
    },
    {
      field: 'questionario',
      sortable: true,
      comparator: () => false,
      filter: 'TextFilter',
      filterParams: {
        module: 'questionarios',
        fetch: 'listarQuestionarios',
        colDef: {
          field: 'questionario',
        },
      },
      headerName: Vuetify.framework.lang.t('$vuetify.questionarios'),
      maxWidth: 750,
      minWidth: 750,
    },
    {
      field: 'dataRegistro',
      sortable: true,
      comparator: () => false,
      filter: 'DateFilter',
      headerName: Vuetify.framework.lang.t('$vuetify.data'),
      maxWidth: 150,
      minWidth: 150,
    },
    {
      field: 'statusQuestionario',
      sortable: true,
      comparator: () => false,
      filter: 'SetFilter',
      filterParams: {
        module: 'questionarios',
        fetch: 'listarQuestionarios',
        filterSet: [
          'EM CADASTRO',
          'FINALIZADO',
        ],
      },
      headerName: Vuetify.framework.lang.t('$vuetify.situacao'),
      maxWidth: 150,
      minWidth: 150,
    },
  ],
};
